<template>
  <template v-if="isLoading">
    <!-- BuyBox Skeleton -->
    <div class="space-y-4">
      <!-- Varyant/Basit Ürün Skeleton -->
      <div class="space-y-3">
        <USkeleton class="h-6 w-32" />
        <div class="flex flex-wrap gap-2">
          <USkeleton v-for="i in 4" :key="i" class="h-10 w-20" />
        </div>
      </div>

      <!-- AddToCart Skeleton -->
      <div class="space-y-6">
        <div class="flex items-center justify-between">
          <USkeleton class="h-6 w-16" />
          <div class="inline-flex items-center gap-2">
            <USkeleton class="h-9 w-9" />
            <USkeleton class="h-6 w-8" />
            <USkeleton class="h-9 w-9" />
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <USkeleton class="h-12 w-full" />
          <USkeleton class="h-12 w-full" />
        </div>

        <div class="text-center">
          <USkeleton class="mx-auto h-5 w-64" />
        </div>
      </div>
    </div>
  </template>

  <template v-else>
    <FrontendProductBuyBoxSimple v-if="productBuyboxStore.isBasic" :data="productBuyboxStore.buyboxData"
      class="space-y-4" />

    <FrontendProductBuyBoxVariant v-else-if="productBuyboxStore.isVariant"
      :variations="productBuyboxStore.buyboxData?.variations" :product-id="productId" class="space-y-4" />

</template>
</template>

<script setup>
const props = defineProps({
  productUrl: {
    type: String,
    required: true
  },
  productId: {
    type: Number,
    required: true
  }
})

const route = useRoute()
const productBuyboxStore = useProductBuyboxStore()
const isLoading = ref(true)

// Sayfa yüklendiğinde çalışacak fonksiyon
const loadData = async () => {
  isLoading.value = true
  try {
    await productBuyboxStore.fetchBuyboxData(props.productUrl)
  } catch (error) {
    // Eğer mid parametresi varsa ve 404 hatası alındıysa, parametresiz URL'ye yönlendir
    if (route.query.mid && error.statusCode === 404) {
      // URL'den mid parametresini kaldır
      const query = { ...route.query }
      delete query.mid

      // Parametresiz URL'ye yönlendir
      await navigateTo({ path: route.path, query }, { replace: true })

      // Veriyi tekrar yükle
      await productBuyboxStore.fetchBuyboxData(props.productUrl)
    }
  } finally {
    isLoading.value = false
  }
}

// Sayfa yüklendiğinde veriyi yükle
onMounted(loadData)

</script>
